import React from 'react';
import { Box, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Mention as MentionPillType } from '../../../Room/components/BuyerCopilotChats/MentionsNode/MentionPill';
import Message from './Message';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(3),
  },
  messageBox: {
    backgroundColor: 'var(--buyer-copilot-user-message-bg)',
    color: theme.palette.common.white,
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    maxWidth: '80%',
    wordBreak: 'break-word',
  },
  messageText: {
    fontSize: 'var(--label-medium-accent-font-size)',
    lineHeight: 'var(--label-medium-accent-line-heigh)',
    marginBottom: theme.spacing(0.5),
    textAlign: 'right',
  },
  metadata: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: `var(--label-small-accent-font-size)`,
    fontWeight: `var(--label-small-accent-font-weight)`,
    lineHeight: `var(--label-small-accent-line-height)`,
    opacity: 0.7,
  },
  avatar: {
    width: 24,
    height: 24,
    alignSelf: 'flex-end',
    backgroundColor: 'var(--avatar-background-default)',
    fontSize: 'var(--label-medium-accent-font-size)',
    fontWeight: 'var(--label-medium-accent-font-weight)',
    lineHeight: 'var(--label-medium-accent-line-height)',
    color: theme.palette.text.primary,
  },
}));

interface UserMessageProps {
  message: string;
  mentions?: MentionPillType[];
  onMentionClick?: (mention: MentionPillType) => void;
}

const UserMessage: React.FC<UserMessageProps> = (
  props: UserMessageProps
): JSX.Element => {
  const classes = useStyles();
  const { message, mentions, onMentionClick } = props;

  return (
    <Box className={classes.container}>
      <Box className={classes.messageBox}>
        <Message
          message={message}
          mentions={mentions}
          onMentionClick={onMentionClick}
        />
      </Box>
    </Box>
  );
};

export default UserMessage;
